/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-24 15:08:14
 * @Description:
 * @FilePath: \mobile-revive\src\assets\js\clamp.js
 */

/**
 * Clamps a text node.
 * @param {HTMLElement} element. Element containing the text node to clamp.
 * @param {Object} options. Options to pass to the clamper.
 */
function clamp(element, options) {
    let wareNameText = element.innerHTML
    let heightSome = element.clientHeight// 获取内容当前的高度
    // let aloneHeight = options.lineHeigth; // 一行高度
    let aloneHeight = options.lineHeigth + 3 // 一行高度
    let lineHeight = options.clamp * aloneHeight
    console.log('h1:' + heightSome, lineHeight)
    if (heightSome > lineHeight) { // 这个42数字是两行的时候的高度，根据你设定的字体大小有关
        for (let i = 0; heightSome > lineHeight; i++) {
            // 每次删掉最后一个然后返回
            wareNameText = wareNameText.substring(0, wareNameText.length - 1)
            // 重新返回的字符在写在span里面 ，计算新的高度
            element.innerHTML = wareNameText
            heightSome = element.clientHeight
        }
        console.log('h2:' + heightSome, lineHeight)
        // 得到正好符合高度的字符，删除最后一个变为省略号 填充在页面里
        let newText = wareNameText.substring(0, wareNameText.length - 2) + '...'
        element.innerHTML = newText
    } else {
        element.innerHTML = wareNameText
    }
}
module.exports = {
    clamp
}
